import React from "react";
import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import FinalCTA from "@/components/FinalCTA";
import { CheckCircle2 } from "lucide-react";
import { useT } from "@/hooks/useT";

export default function POS() {
  const t = useT();
  const BULLETS = [
    t("Menu të personalizueshme me kategori",   "Customisable menus with categories"),
    t("Faturë në dhomë ose veçmas, si dëshiron klienti","Bill to the room or separately, guest's choice"),
    t("Disa pika POS njëkohësisht",              "Multiple POS terminals at once"),
    t("Lidhje me sistemin fiskal",                "Integrated with the fiscal system"),
    t("Raporte shitjesh dhe inventar",            "Sales and inventory reports"),
    t("Funksionon në tablet, kompjuter ose telefon","Runs on tablet, laptop or phone"),
  ];
  return (
    <>
      <SEO
        title={t("POS për Hotele — Bar, Restorant, Room Service","Hotel POS — Bar, Restaurant, Room Service")}
        description={t(
          "POS-i i Akomoda për bar, restorant dhe room service. Porositë shkruhen vetë në llogarinë e klientit dhe shfaqen në faturën finale.",
          "Akomoda's POS for bar, restaurant and room service. Orders post automatically to the guest folio and land on the final invoice."
        )}
      />
      <PageHeader
        eyebrow="POS"
        title={t("POS për bar, restorant dhe room service","POS for bar, restaurant and room service")}
        description={t(
          "Porositë e klientit hyjnë vetë në faturën e dhomës. Pa konfuzion. Pa harresa. Pa mbledhje me dorë në fund të qëndrimit.",
          "Guest orders flow straight onto the room bill. No confusion. Nothing forgotten. No manual totalling at check-out."
        )}
        ctas={[{ to: "/demo", label: t("Kërko Demo","Request Demo") }]}
        breadcrumb={[
          { label: t("Platforma","Platform"), to: "/platforma" },
          { label: "POS" },
        ]}
      />
      <section className="bg-surface-1">
        <div className="container-akm grid gap-10 py-14 md:grid-cols-12 md:py-20">
          <div className="md:col-span-6">
            <h2 className="h2-akm">{t("POS i ndërtuar për hotele, jo për restorante","A POS built for hotels, not restaurants")}</h2>
            <p className="lead mt-3">
              {t(
                "Bar-i, restoranti dhe room service-i janë pjesë e të njëjtit sistem. Porosia shkruhet menjëherë në llogarinë e dhomës dhe del në faturën finale gjatë check-out.",
                "The bar, restaurant and room service all live in the same system. Orders post to the room folio instantly and show up on the final invoice at check-out."
              )}
            </p>
            <ul className="mt-6 space-y-2 text-sm text-ink">
              {BULLETS.map((b) => (
                <li key={b} className="flex items-start gap-2">
                  <CheckCircle2 size={16} className="mt-0.5 shrink-0 text-[#FF7A00]" /> {b}
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-6">
            <div className="rounded-xl border border-line bg-white p-6 shadow-card">
              <div className="text-xs font-semibold uppercase tracking-wider text-slate2">POS — {t("Bar Onufri","Onufri Bar")}</div>
              <div className="mt-3 space-y-2 text-sm">
                {[
                  ["Espresso", "€1.50", "x2"],
                  [t("Birrë Tirana 0.5L","Tirana Beer 0.5L"), "€3.00", "x3"],
                  [t("Sallatë Greke","Greek Salad"), "€6.50", "x1"],
                  [t("Verë e kuqe Kallmet","Kallmet Red Wine"), "€18.00", "x1"],
                ].map(([n, p, q]) => (
                  <div key={n} className="flex items-center justify-between rounded-md border border-line p-2.5">
                    <div className="font-medium text-ink">{n}</div>
                    <div className="flex items-center gap-3 text-slate2">
                      <span>{q}</span>
                      <span className="font-display font-bold text-ink">{p}</span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-4 flex items-center justify-between border-t border-line pt-3 text-sm">
                <span className="text-slate2">{t("Totali → Dhoma 201","Total → Room 201")}</span>
                <span className="font-display text-lg font-bold text-ink">€36.50</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FinalCTA />
    </>
  );
}
